const keyPrefix = "c260601_";

const LINE_CLIENT_ID = "2007287696";
//const API_PATH = "https://stg.ototo-line.com/"
const API_PATH = "https://ototo-line.com/"
//const API_PATH = "http://localhost:3000/"
const API_CALLBACK_PATH = API_PATH;
const API_INFO_PATH = API_PATH;
const API_UPLOAD_PATH = API_PATH + "upload";

const updateList = (data) => {
    
    if( "token" in data ){
      this.setCookie( "token", data["token"] );
    }
    
    let foundModelList = this.getCookie("found_model");
    if(foundModelList === undefined){
        foundModelList = false;
    }else{
        foundModelList = JSON.parse(foundModelList);
    }
    if(!Array.isArray(foundModelList)){
        foundModelList = [];
        for( var j = 0;j < this.objCountList.length;j++ ){
            foundModelList[j] = [];
            for( var i = 0;i < this.objCountList[j];i++ ){
                foundModelList[j][i] = false;
            }
        }
    }

    if( "list" in data ){
      for( let idx in data["list"] ){
        const typeId = data["list"][idx];

        var param = typeId.split("_");
        var gid = parseInt(param[0]) - 1;
        var oid = parseInt(param[1]) - 1;
      
        foundModelList[gid][oid] = true;
      }
    }    
    this.setCookie( "found_model", JSON.stringify(foundModelList) );

    return foundModelList;
}
exports.lineClientId = LINE_CLIENT_ID;
exports.apiCallbackUrl = API_CALLBACK_PATH;
exports.getUserInfo = (successProc, failedProc) => {
    
    const token = this.getCookie("token");
    
    
    fetch(API_INFO_PATH, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json'
        },
        body: JSON.stringify({
          "token": token
        })
    })
    .then(response => {
        if (!response.ok) {
            throw new Error('Network response was not ok');
        }
        return response.json()
    })
    .then(data => {
      updateList(data);        
      successProc(data);
    })
    .catch(error => {
      console.error(error);
      failedProc();
    });
}
exports.uploadCollection = (type, successProc, failedProc) => {
    
  const token = this.getCookie("token");
    
  fetch(API_UPLOAD_PATH, {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json'
    },
    body: JSON.stringify({
      "token": token,
      "type": type,
    })
  })
  .then(response => {
    if (!response.ok) {
      throw new Error('Network response was not ok');
    }
    return response.json()
  })
  .then(data => {
    updateList(data);
    successProc(data);
  })
  .catch(error => {
    console.error(error);
    failedProc();
  });
} 


const maskImages = {
    "1_1": {
        filter: [ "./images/mask/1_1/filter_001.png", "./images/mask/1_1/filter_002.png", "./images/mask/1_1/filter_003.png", "./images/mask/1_1/filter_004.png" ],
        point: [ { x: 87, y: 81 },
                 { x: 127, y: 82 },
                 { x: 107, y: 162 },
                 { x: 165, y: 135 } ],
        match: 0.55,
        dis_match: 0.55,
        is_special: false
    },
    "1_2": {
        filter: [ "./images/mask/1_2/filter_001.png", "./images/mask/1_2/filter_002.png", "./images/mask/1_2/filter_003.png" ],
        point: [ { x: 120, y: 161 },
                 { x: 75, y: 81 },
                 { x: 166, y: 81 }],
        match: 0.55,
        dis_match: 0.55,
        is_special: false
    },
    "1_3": {
        filter: [ "./images/mask/1_3/filter_001.png", "./images/mask/1_3/filter_002.png", "./images/mask/1_3/filter_003.png", "./images/mask/1_3/filter_004.png" ],
        point: [ { x: 91, y: 85 },
                 { x: 156, y: 95 },
                 { x: 116, y: 130 },
                 { x: 121, y: 177 }],
        match: 0.55,
        dis_match: 0.55,
        is_special: false
    },
    "1_4": {
        filter: [ "./images/mask/1_4/filter_001.png", "./images/mask/1_4/filter_002.png", "./images/mask/1_4/filter_003.png", "./images/mask/1_4/filter_004.png", "./images/mask/1_4/filter_005.png" ],
        point: [ { x: 100, y: 78 },
                 { x: 170, y: 108 },
                 { x: 80,  y: 128 },
                 { x: 92, y: 172 },
                 { x: 152, y: 173 }],
        match: 0.55,
        dis_match: 0.55,
        is_special: false
    },
    "1_5": {
        filter: [ "./images/mask/1_5/filter_001.png", "./images/mask/1_5/filter_002.png", "./images/mask/1_5/filter_003.png", "./images/mask/1_5/filter_004.png", "./images/mask/1_5/filter_005.png", "./images/mask/1_5/filter_006.png" ],
        point: [ { x: 101, y: 73 },
                 { x: 81, y: 118 },
                 { x: 101, y: 156 },
                 { x: 141, y: 73 },
                 { x: 161, y: 115 },
                 { x: 151, y: 163 } ],
        match: 0.55,
        dis_match: 0.55,
        is_special: false
    },
    "1_6": {
        filter: [ "./images/mask/1_6/filter_001.png", "./images/mask/1_6/filter_002.png", "./images/mask/1_6/filter_003.png", "./images/mask/1_6/filter_004.png" ],
        point: [ { x: 107, y: 85 },
                 { x: 142, y: 95 },
                 { x: 87,  y: 145 },
                 { x: 157, y: 148 }],
        match: 0.55,
        dis_match: 0.55,
        is_special: false
    },
    "1_7": {
        filter: [ "./images/mask/1_7/filter_001.png", "./images/mask/1_7/filter_002.png", "./images/mask/1_7/filter_003.png", "./images/mask/1_7/filter_004.png", "./images/mask/1_7/filter_005.png" ],
        point: [ { x: 123, y: 87 },
                 { x: 88, y: 120 },
                 { x: 158, y: 130 },
                 { x: 98, y: 170 },
                 { x: 153, y: 170 }],
        match: 0.55,
        dis_match: 0.55,
        is_special: false
    },
    "1_8": {
        filter: [ "./images/mask/1_8/filter_001.png", "./images/mask/1_8/filter_002.png", "./images/mask/1_8/filter_003.png", "./images/mask/1_8/filter_004.png" ],
        point: [ { x: 97,  y: 94 },
                 { x: 161, y: 93 },
                 { x: 96,  y: 153 },
                 { x: 156, y: 148 }],
        match: 0.55,
        dis_match: 0.55,
        is_special: false
    },
    "1_9": {
        filter: [ "./images/mask/1_9/filter_001.png", "./images/mask/1_9/filter_002.png", "./images/mask/1_9/filter_003.png", "./images/mask/1_9/filter_004.png" ],
        point: [ { x: 93, y: 99 },
                 { x: 153, y: 99 },
                 { x: 98, y: 154 },
                 { x: 153, y: 149 }],
        match: 0.55,
        dis_match: 0.55,
        is_special: false
    },
    "1_10": {
        filter: [ "./images/mask/1_10/filter_001.png", "./images/mask/1_10/filter_002.png", "./images/mask/1_10/filter_003.png", "./images/mask/1_10/filter_004.png" ],
        point: [ { x: 130, y: 70 },
                 { x: 128, y: 127 },
                 { x: 160, y: 165 },
                 { x: 85, y: 167 }],
        match: 0.55,
        dis_match: 0.55,
        is_special: false
    },
    "1_11": {
        filter: [ "./images/mask/1_11/filter_001.png", "./images/mask/1_11/filter_002.png", "./images/mask/1_11/filter_003.png", "./images/mask/1_11/filter_004.png" ],
        point: [ { x: 92, y: 94 },
                 { x: 117, y: 91 },
                 { x: 97, y: 154 },
                 { x: 162, y: 129 }],
        match: 0.55,
        dis_match: 0.55,
        is_special: false
    },
    "1_12": {
        filter: [ "./images/mask/1_12/filter_001.png", "./images/mask/1_12/filter_002.png", "./images/mask/1_12/filter_003.png", "./images/mask/1_12/filter_004.png", "./images/mask/1_12/filter_005.png" ],
        point: [ { x: 119, y: 88 },
                 { x: 87,  y: 125 },
                 { x: 162, y: 141 },
                 { x: 99, y: 181 },
                 { x: 152, y: 181 }],
        match: 0.55,
        dis_match: 0.55,
        is_special: false
    },
    "1_13": {
        filter: [ "./images/mask/1_13/filter_001.png", "./images/mask/1_13/filter_002.png", "./images/mask/1_13/filter_003.png", "./images/mask/1_13/filter_004.png", "./images/mask/1_13/filter_005.png" ],
        point: [ { x: 121, y: 68 },
                 { x: 61,  y: 93 },
                 { x: 181, y: 88 },
                 { x: 91, y: 168 },
                 { x: 161, y: 168 } ],
        match: 0.55,
        dis_match: 0.55,
        is_special: false
    },
    "1_14": {
        filter: [ "./images/mask/1_14/filter_001.png", "./images/mask/1_14/filter_002.png", "./images/mask/1_14/filter_003.png", "./images/mask/1_14/filter_004.png" ],
        point: [ { x: 75,  y: 125 },
                 { x: 120, y: 100 },
                 { x: 170, y: 120 },
                 { x: 110, y: 140 } ],
        match: 0.55,
        dis_match: 0.55,
        is_special: false
    },
    "1_15": {
        filter: [ "./images/mask/1_15/filter_001.png", "./images/mask/1_15/filter_002.png", "./images/mask/1_15/filter_003.png", "./images/mask/1_15/filter_004.png" ],
        point: [ { x: 75,  y: 100 },
                 { x: 75,  y: 160 },
                 { x: 165, y: 160 },
                 { x: 175, y: 130 } ],
        match: 0.55,
        dis_match: 0.55,
        is_special: false
    },
    "1_16": {
        filter: [ "./images/mask/1_16/filter_001.png", "./images/mask/1_16/filter_002.png", "./images/mask/1_16/filter_003.png", "./images/mask/1_16/filter_004.png" ],
        point: [ { x: 120, y: 190 },
                 { x: 160, y: 110 },
                 { x: 85,  y: 125 },
                 { x: 130, y: 50 } ],
        match: 0.55,
        dis_match: 0.55,
        is_special: false
    },
    "1_17": {
        filter: [ "./images/mask/1_17/filter_001.png", "./images/mask/1_17/filter_002.png", "./images/mask/1_17/filter_003.png", "./images/mask/1_17/filter_004.png" ],
        point: [ { x: 160, y: 165 },
                 { x: 85,  y: 165 },
                 { x: 90,  y: 95 },
                 { x: 135, y: 100 } ],
        match: 0.55,
        dis_match: 0.55,
        is_special: false
    },
    "1_18": {
        filter: [ "./images/mask/1_18/filter_001.png", "./images/mask/1_18/filter_002.png", "./images/mask/1_18/filter_003.png", "./images/mask/1_18/filter_004.png" ],
        point: [ { x: 175, y: 155 },
                 { x: 95,  y: 90 },
                 { x: 80,  y: 130 },
                 { x: 120, y: 160 } ],
        match: 0.55,
        dis_match: 0.55,
        is_special: false
    },
    "1_19": {
        filter: [ "./images/mask/1_19/filter_001.png", "./images/mask/1_19/filter_002.png", "./images/mask/1_19/filter_003.png", "./images/mask/1_19/filter_004.png" ],
        point: [ { x: 140, y: 80 },
                 { x: 175, y: 140 },
                 { x: 110, y: 160 },
                 { x: 90,  y: 80 } ],
        match: 0.55,
        dis_match: 0.55,
        is_special: false
    },
    "1_20": {
        filter: [ "./images/mask/1_20/filter_001.png", "./images/mask/1_20/filter_002.png", "./images/mask/1_20/filter_003.png", "./images/mask/1_20/filter_004.png" ],
        point: [ { x: 185, y: 75 },
                 { x: 80,  y: 125 },
                 { x: 120, y: 125 },
                 { x: 180, y: 135 } ],
        match: 0.55,
        dis_match: 0.55,
        is_special: true
    },
    "1_21": {
        filter: [ "./images/mask/1_21/filter_001.png", "./images/mask/1_21/filter_002.png", "./images/mask/1_21/filter_003.png", "./images/mask/1_21/filter_004.png" ],
        point: [ { x: 150, y: 145 },
                 { x: 115, y: 140 },
                 { x: 90,  y: 90 },
                 { x: 130, y: 80 } ],
        match: 0.55,
        dis_match: 0.55,
        is_special: false
    },
    "1_22": {
        filter: [ "./images/mask/1_22/filter_001.png", "./images/mask/1_22/filter_002.png", "./images/mask/1_22/filter_003.png", "./images/mask/1_22/filter_004.png" ],
        point: [ { x: 110, y: 170 },
                 { x: 90,  y: 115 },
                 { x: 105, y: 62 },
                 { x: 130, y: 140 } ],
        match: 0.55,
        dis_match: 0.55,
        is_special: false
    },
    "1_23": {
        filter: [ "./images/mask/1_23/filter_001.png", "./images/mask/1_23/filter_002.png", "./images/mask/1_23/filter_003.png", "./images/mask/1_23/filter_004.png" ],
        point: [ { x: 105, y: 70 },
                 { x: 115, y: 130 },
                 { x: 95,  y: 155 },
                 { x: 145, y: 180 } ],
        match: 0.55,
        dis_match: 0.55,
        is_special: false
    },
    "1_24": {
        filter: [ "./images/mask/1_24/filter_001.png", "./images/mask/1_24/filter_002.png", "./images/mask/1_24/filter_003.png", "./images/mask/1_24/filter_004.png", "./images/mask/1_24/filter_005.png" ],
        point: [ { x: 170, y: 60 },
                 { x: 55, y: 60 },
                 { x: 115, y: 50 },
                 { x: 125, y: 85 },
                 { x: 115, y: 125 } ],
        match: 0.55,
        dis_match: 0.55,
        is_special: false
    },
    "1_25": {
        filter: [ "./images/mask/1_25/filter_001.png", "./images/mask/1_25/filter_002.png", "./images/mask/1_25/filter_003.png", "./images/mask/1_25/filter_004.png", "./images/mask/1_25/filter_005.png" ],
        point: [ { x: 115, y: 70 },
                 { x: 105, y: 120 },
                 { x: 135, y: 115 },
                 { x: 135, y: 155 },
                 { x: 95,  y: 160 } ],
        match: 0.55,
        dis_match: 0.55,
        is_special: true
    },
    "1_26": {
        filter: [ "./images/mask/1_26/filter_001.png", "./images/mask/1_26/filter_002.png", "./images/mask/1_26/filter_003.png", "./images/mask/1_26/filter_004.png" ],
        point: [ { x: 95,  y: 70 },
                 { x: 90,  y: 130 },
                 { x: 150, y: 130 },
                 { x: 135, y: 175 } ],
        match: 0.55,
        dis_match: 0.55,
        is_special: true
    },
    "1_27": {
        filter: [ "./images/mask/1_27/filter_001.png", "./images/mask/1_27/filter_002.png", "./images/mask/1_27/filter_003.png", "./images/mask/1_27/filter_004.png", "./images/mask/1_27/filter_005.png", "./images/mask/1_27/filter_006.png" ],
        point: [ { x: 94, y: 58 },
                 { x: 79, y: 118 },
                 { x: 84, y: 163 },
                 { x: 129, y: 108 },
                 { x: 134, y: 173 },
                 { x: 179, y: 148 } ],
        match: 0.55,
        dis_match: 0.55,
        is_special: false
    },
    "1_28": {
        filter: [ "./images/mask/1_28/filter_001.png", "./images/mask/1_28/filter_002.png", "./images/mask/1_28/filter_003.png", "./images/mask/1_28/filter_004.png" ],
        point: [ { x: 90, y: 150 },
                 { x: 90, y: 95 },
                 { x: 145, y: 95 },
                 { x: 155, y: 140 } ],
        match: 0.55,
        dis_match: 0.55,
        is_special: false
    },
    "1_29": {
        filter: [ "./images/mask/1_29/filter_001.png", "./images/mask/1_29/filter_002.png", "./images/mask/1_29/filter_003.png" ],
        point: [ { x: 163, y: 115 },
                 { x: 94, y: 91 },
                 { x: 98, y: 140 }],
        match: 0.55,
        dis_match: 0.55,
        is_special: false
    },
    "1_30": {
        filter: [ "./images/mask/1_30/filter_001.png", "./images/mask/1_30/filter_002.png", "./images/mask/1_30/filter_003.png", "./images/mask/1_30/filter_004.png", "./images/mask/1_30/filter_005.png" ],
        point: [ { x: 90, y: 58 },
                 { x: 110, y: 103 },
                 { x: 100, y: 158 },
                 { x: 140, y: 158 },
                 { x: 170, y: 168 } ],
        match: 0.55,
        dis_match: 0.55,
        is_special: false
    },
    "1_31": {
        filter: [ "./images/mask/1_31/filter_001.png", "./images/mask/1_31/filter_002.png", "./images/mask/1_31/filter_003.png", "./images/mask/1_31/filter_004.png"],
        point: [ { x: 130, y: 90 },
                 { x: 150, y: 110 },
                 { x: 95,  y: 115 },
                 { x: 120, y: 150 }],
        match: 0.55,
        dis_match: 0.55,
        is_special: false
    },
    "1_32": {
        filter: [ "./images/mask/1_32/filter_001.png", "./images/mask/1_32/filter_002.png", "./images/mask/1_32/filter_003.png", "./images/mask/1_32/filter_004.png"],
        point: [ { x: 130, y: 70 },
                 { x: 170, y: 135 },
                 { x: 90,  y: 125 },
                 { x: 145, y: 140 }],
        match: 0.55,
        dis_match: 0.55,
        is_special: false
    },
    "1_33": {
        filter: [ "./images/mask/1_33/filter_001.png", "./images/mask/1_33/filter_002.png", "./images/mask/1_33/filter_003.png", "./images/mask/1_33/filter_004.png" ],
        point: [ { x: 160, y: 120 },
                 { x: 85, y: 85 },
                 { x: 90, y: 140 },
                 { x: 130, y: 150 } ],
        match: 0.55,
        dis_match: 0.55,
        is_special: false
    },
    "1_34": {
        filter: [ "./images/mask/1_34/filter_001.png", "./images/mask/1_34/filter_002.png", "./images/mask/1_34/filter_003.png", "./images/mask/1_34/filter_004.png" ],
        point: [ { x: 135, y: 95 },
                 { x: 105, y: 85 },
                 { x: 100, y: 135 },
                 { x: 135, y: 135 } ],
        match: 0.55,
        dis_match: 0.55,
        is_special: false
    },
    "1_35": {
        filter: [ "./images/mask/1_35/filter_001.png", "./images/mask/1_35/filter_002.png", "./images/mask/1_35/filter_003.png", "./images/mask/1_35/filter_004.png"],
        point: [ { x: 175, y: 105 },
                 { x: 160, y: 85 },
                 { x: 100, y: 115 },
                 { x: 105, y: 140 } ],
        match: 0.55,
        dis_match: 0.55,
        is_special: false
    },
    "1_36": {
        filter: [ "./images/mask/1_36/filter_001.png", "./images/mask/1_36/filter_002.png", "./images/mask/1_36/filter_003.png", "./images/mask/1_36/filter_004.png" ],
        point: [ { x: 155, y: 140 },
                 { x: 150, y: 90 },
                 { x: 110, y: 75 },
                 { x: 85,  y: 90 } ],
        match: 0.55,
        dis_match: 0.55,
        is_special: false
    },
    "1_37": {
        filter: [ "./images/mask/1_37/filter_001.png", "./images/mask/1_37/filter_002.png", "./images/mask/1_37/filter_003.png", "./images/mask/1_37/filter_004.png" ],
        point: [ { x: 155, y: 113 },
                 { x: 155, y: 150 },
                 { x: 85, y: 85 },
                 { x: 100, y: 135 } ],
        match: 0.55,
        dis_match: 0.55,
        is_special: false
    },
    "1_38": {
        filter: [ "./images/mask/1_38/filter_001.png", "./images/mask/1_38/filter_002.png", "./images/mask/1_38/filter_003.png", "./images/mask/1_38/filter_004.png"],
        point: [ { x: 155, y: 95 },
                 { x: 145, y: 145 },
                 { x: 75, y: 115 },
                 { x: 110, y: 145 } ],
        match: 0.55,
        dis_match: 0.55,
        is_special: false
    },
    "1_39": {
        filter: [ "./images/mask/1_39/filter_001.png", "./images/mask/1_39/filter_002.png", "./images/mask/1_39/filter_003.png", "./images/mask/1_39/filter_004.png", "./images/mask/1_39/filter_005.png" ],
        point: [ { x: 85, y: 70 },
                 { x: 180, y: 140 },
                 { x: 85, y: 155 },
                 { x: 135, y: 165 },
                 { x: 90, y: 115 } ],
        match: 0.55,
        dis_match: 0.55,
        is_special: false
    },
    "1_40": {
        filter: [ "./images/mask/1_40/filter_001.png", "./images/mask/1_40/filter_002.png", "./images/mask/1_40/filter_003.png", "./images/mask/1_40/filter_004.png" ],
        point: [ { x: 85, y: 90 },
                 { x: 80, y: 125 },
                 { x: 155, y: 120 },
                 { x: 132, y: 160 } ],
        match: 0.55,
        dis_match: 0.55,
        is_special: false
    },
    "1_41": {
        filter: [ "./images/mask/1_41/filter_001.png", "./images/mask/1_41/filter_002.png", "./images/mask/1_41/filter_003.png", "./images/mask/1_41/filter_004.png" ],
        point: [ { x: 75, y: 80 },
                 { x: 125, y: 95 },
                 { x: 145, y: 160 },
                 { x: 125, y: 150 } ],
        match: 0.55,
        dis_match: 0.55,
        is_special: false
    },
    "1_42": {
        filter: [ "./images/mask/1_42/filter_001.png", "./images/mask/1_42/filter_002.png", "./images/mask/1_42/filter_003.png", "./images/mask/1_42/filter_004.png" ],
        point: [ { x: 135, y: 110 },
                 { x: 110, y: 110 },
                 { x: 135, y: 165 },
                 { x: 100, y: 155 } ],
        match: 0.55,
        dis_match: 0.55,
        is_special: false
    },
    "1_43": {
        filter: [ "./images/mask/1_43/filter_001.png", "./images/mask/1_43/filter_002.png", "./images/mask/1_43/filter_003.png", "./images/mask/1_43/filter_004.png" ],
        point: [ { x: 130, y: 105 },
                 { x: 100, y: 105 },
                 { x: 100, y: 145 },
                 { x: 140, y: 140 } ],
        match: 0.55,
        dis_match: 0.55,
        is_special: false
    },
    
    "2_1": {
        filter: [ "./images/mask/2_1/filter_001.png", "./images/mask/2_1/filter_002.png", "./images/mask/2_1/filter_003.png", "./images/mask/2_1/filter_004.png" ],
        point: [ { x: 105, y: 82 },
                 { x: 135, y: 87 },
                 { x: 155, y: 144 },
                 { x: 95, y: 177 }],
        match: 0.55,
        dis_match: 0.55,
        is_special: false
    },
    "2_2": {
        filter: [ "./images/mask/2_2/filter_001.png", "./images/mask/2_2/filter_002.png", "./images/mask/2_2/filter_003.png", "./images/mask/2_2/filter_004.png" ],
        point: [ { x: 73, y: 157 },
                 { x: 172, y: 151 },
                 { x: 112, y: 95 },
                 { x: 145, y: 87 }],
        match: 0.55,
        dis_match: 0.55,
        is_special: false
    },
    "2_3": {
        filter: [ "./images/mask/2_3/filter_001.png", "./images/mask/2_3/filter_002.png", "./images/mask/2_3/filter_003.png", "./images/mask/2_3/filter_004.png", "./images/mask/2_3/filter_005.png" ],
        point: [ { x: 114, y: 79 },
                 { x: 144, y: 74 },
                 { x: 94, y: 164 },
                 { x: 154, y: 129 },
                 { x: 149, y: 171 }],
        match: 0.55,
        dis_match: 0.55,
        is_special: false
    },
    "2_4": {
        filter: [ "./images/mask/2_4/filter_001.png", "./images/mask/2_4/filter_002.png", "./images/mask/2_4/filter_003.png", "./images/mask/2_4/filter_004.png", "./images/mask/2_4/filter_005.png" ],
        point: [ { x: 108, y: 68 },
                 { x: 98, y: 113 },
                 { x: 88, y: 153 },
                 { x: 138, y: 153 },
                 { x: 138, y: 98 } ],
        match: 0.55,
        dis_match: 0.55,
        is_special: false
    },
    "2_5": {
        filter: [ "./images/mask/2_5/filter_001.png", "./images/mask/2_5/filter_002.png", "./images/mask/2_5/filter_003.png", "./images/mask/2_5/filter_004.png" ],
        point: [ { x: 78, y: 103 },
                 { x: 153, y: 83 },
                 { x: 93, y: 113 },
                 { x: 108, y: 163 } ],
        match: 0.55,
        dis_match: 0.55,
        is_special: false
    },
    "2_6": {
        filter: [ "./images/mask/2_6/filter_001.png", "./images/mask/2_6/filter_002.png", "./images/mask/2_6/filter_003.png", "./images/mask/2_6/filter_004.png", "./images/mask/2_6/filter_005.png" ],
        point: [ { x: 89, y: 93 },
                 { x: 84, y: 143 },
                 { x: 139, y: 163 },
                 { x: 174, y: 128 },
                 { x: 174, y: 163 } ],
        match: 0.55,
        dis_match: 0.55,
        is_special: false
    },
    "2_7": {
        filter: [ "./images/mask/2_7/filter_001.png", "./images/mask/2_7/filter_002.png", "./images/mask/2_7/filter_003.png", "./images/mask/2_7/filter_004.png" ],
        point: [ { x: 71, y: 104 },
                 { x: 166, y: 84 },
                 { x: 121, y: 129 },
                 { x: 116, y: 169 } ],
        match: 0.55,
        dis_match: 0.55,
        is_special: false
    },
    "2_8": {
        filter: [ "./images/mask/2_8/filter_001.png", "./images/mask/2_8/filter_002.png", "./images/mask/2_8/filter_003.png", "./images/mask/2_8/filter_004.png" ],
        point: [ { x: 80, y: 100 },
                 { x: 155, y: 110 },
                 { x: 135, y: 165 },
                 { x: 170, y: 145 } ],
        match: 0.55,
        dis_match: 0.55,
        is_special: false
    },
    "2_9": {
        filter: [ "./images/mask/2_9/filter_001.png", "./images/mask/2_9/filter_002.png", "./images/mask/2_9/filter_003.png", "./images/mask/2_9/filter_004.png", "./images/mask/2_9/filter_005.png" ],
        point: [ { x: 140, y: 60 },
                 { x: 80,  y: 115 },
                 { x: 150, y: 130 },
                 { x: 70,  y: 155 },
                 { x: 115, y: 195 } ],
        match: 0.55,
        dis_match: 0.55,
        is_special: false
    },
    "2_10": {
        filter: [ "./images/mask/2_10/filter_001.png", "./images/mask/2_10/filter_002.png", "./images/mask/2_10/filter_003.png", "./images/mask/2_10/filter_004.png" ],
        point: [ { x: 100, y: 100 },
                 { x: 170, y: 130 },
                 { x: 95,  y: 165 },
                 { x: 140, y: 165 } ],
        match: 0.55,
        dis_match: 0.55,
        is_special: false
    },
    "2_11": {
        filter: [ "./images/mask/2_11/filter_001.png", "./images/mask/2_11/filter_002.png", "./images/mask/2_11/filter_003.png", "./images/mask/2_11/filter_004.png", "./images/mask/2_11/filter_005.png" ],
        point: [ { x: 120, y: 80 },
                 { x: 85,  y: 130 },
                 { x: 150, y: 120 },
                 { x: 100, y: 160 },
                 { x: 140, y: 160 } ],
        match: 0.55,
        dis_match: 0.55,
        is_special: false
    },
    "2_12": {
        filter: [ "./images/mask/2_12/filter_001.png", "./images/mask/2_12/filter_002.png", "./images/mask/2_12/filter_003.png", "./images/mask/2_12/filter_004.png" ],
        point: [ { x: 115, y: 90 },
                 { x: 100, y: 155 },
                 { x: 140, y: 150 },
                 { x: 115, y: 195 } ],
        match: 0.55,
        dis_match: 0.55,
        is_special: false
    },
    "2_13": {
        filter: [ "./images/mask/2_13/filter_001.png", "./images/mask/2_13/filter_002.png", "./images/mask/2_13/filter_003.png", "./images/mask/2_13/filter_004.png" ],
        point: [ { x: 180, y: 110 },
                 { x: 110, y: 75 },
                 { x: 90,  y: 125 },
                 { x: 100, y: 170 } ],
        match: 0.55,
        dis_match: 0.55,
        is_special: false
    },
    "2_14": {
        filter: [ "./images/mask/2_14/filter_001.png", "./images/mask/2_14/filter_002.png", "./images/mask/2_14/filter_003.png", "./images/mask/2_14/filter_004.png", "./images/mask/2_14/filter_005.png" ],
        point: [ { x: 75,  y: 105 },
                 { x: 120, y: 100 },
                 { x: 180, y: 60 },
                 { x: 180, y: 145 },
                 { x: 120, y: 140 } ],
        match: 0.55,
        dis_match: 0.55,
        is_special: false
    },
    "2_15": {
        filter: [ "./images/mask/2_15/filter_001.png", "./images/mask/2_15/filter_002.png", "./images/mask/2_15/filter_003.png", "./images/mask/2_15/filter_004.png" ],
        point: [ { x: 175, y: 130 },
                 { x: 150, y: 120 },
                 { x: 120, y: 160 },
                 { x: 80,  y: 80 } ],
        match: 0.55,
        dis_match: 0.55,
        is_special: false
    },
    "2_16": {
        filter: [ "./images/mask/2_16/filter_001.png", "./images/mask/2_16/filter_002.png", "./images/mask/2_16/filter_003.png", "./images/mask/2_16/filter_004.png" ],
        point: [ { x: 140, y: 85 },
                 { x: 115, y: 80 },
                 { x: 130, y: 165 },
                 { x: 80,  y: 160 } ],
        match: 0.55,
        dis_match: 0.55,
        is_special: false
    },
    "2_17": {
        filter: [ "./images/mask/2_17/filter_001.png", "./images/mask/2_17/filter_002.png", "./images/mask/2_17/filter_003.png", "./images/mask/2_17/filter_004.png" ],
        point: [ { x: 170, y: 115 },
                 { x: 125, y: 180 },
                 { x: 50,  y: 175 },
                 { x: 65,  y: 75 } ],
        match: 0.55,
        dis_match: 0.55,
        is_special: false
    },
    "2_18": {
        filter: [ "./images/mask/2_18/filter_001.png", "./images/mask/2_18/filter_002.png", "./images/mask/2_18/filter_003.png", "./images/mask/2_18/filter_004.png" ],
        point: [ { x: 80,  y: 160 },
                 { x: 160, y: 80 },
                 { x: 115, y: 80 },
                 { x: 115, y: 160 } ],
        match: 0.55,
        dis_match: 0.55,
        is_special: false
    },
    "2_19": {
        filter: [ "./images/mask/2_19/filter_001.png", "./images/mask/2_19/filter_002.png", "./images/mask/2_19/filter_003.png", "./images/mask/2_19/filter_004.png" ],
        point: [ { x: 130, y: 65 },
                 { x: 90,  y: 100 },
                 { x: 170, y: 170 },
                 { x: 105, y: 175 } ],
        match: 0.55,
        dis_match: 0.55,
        is_special: true
    },
    "2_20": {
        filter: [ "./images/mask/2_20/filter_001.png", "./images/mask/2_20/filter_002.png", "./images/mask/2_20/filter_003.png", "./images/mask/2_20/filter_004.png" ],
        point: [ { x: 80,  y: 80 },
                 { x: 160, y: 100 },
                 { x: 160, y: 155 },
                 { x: 90,  y: 155 } ],
        match: 0.55,
        dis_match: 0.55,
        is_special: true
    },
    "2_21": {
        filter: [ "./images/mask/2_21/filter_001.png", "./images/mask/2_21/filter_002.png", "./images/mask/2_21/filter_003.png", "./images/mask/2_21/filter_004.png" ],
        point: [ { x: 100, y: 100 },
                 { x: 120, y: 105 },
                 { x: 110, y: 145 },
                 { x: 125, y: 145 } ],
        match: 0.55,
        dis_match: 0.55,
        is_special: true
    },
    "2_22": {
        filter: [ "./images/mask/2_22/filter_001.png", "./images/mask/2_22/filter_002.png", "./images/mask/2_22/filter_003.png", "./images/mask/2_22/filter_004.png" ],
        point: [ { x:  60, y: 100 },
                 { x: 115, y: 100 },
                 { x: 100, y: 140 },
                 { x: 165, y: 145 } ],
        match: 0.55,
        dis_match: 0.55,
        is_special: false
    },
    "2_23": {
        filter: [ "./images/mask/2_23/filter_001.png", "./images/mask/2_23/filter_002.png", "./images/mask/2_23/filter_003.png", "./images/mask/2_23/filter_004.png" ],
        point: [ { x:  95, y: 100 },
                 { x: 125, y:  95 },
                 { x:  90, y: 140 },
                 { x: 140, y: 135 } ],
        match: 0.55,
        dis_match: 0.55,
        is_special: false
    },
    "2_24": {
        filter: [ "./images/mask/2_24/filter_001.png", "./images/mask/2_24/filter_002.png", "./images/mask/2_24/filter_003.png" ],
        point: [ { x: 120, y: 105 },
                 { x: 100, y: 155 },
                 { x: 145, y: 160 } ],
        match: 0.55,
        dis_match: 0.55,
        is_special: false
    },
    "2_25": {
        filter: [ "./images/mask/2_25/filter_001.png", "./images/mask/2_25/filter_002.png", "./images/mask/2_25/filter_003.png", "./images/mask/2_25/filter_004.png" ],
        point: [ { x: 105, y: 100 },
                 { x: 130, y: 100 },
                 { x: 105, y: 150 },
                 { x: 135, y: 150 } ],
        match: 0.55,
        dis_match: 0.55,
        is_special: false
    },
    
    "3_1": {
        filter: [ "./images/mask/3_1/filter_001.png", "./images/mask/3_1/filter_002.png", "./images/mask/3_1/filter_003.png", "./images/mask/3_1/filter_004.png" ],
        point: [ { x: 150, y: 115 },
                 { x: 135, y: 145 },
                 { x: 105, y: 120 },
                 { x: 115, y: 145 } ],
        match: 0.55,
        dis_match: 0.55,
        is_special: false
    },
    "3_2": {
        filter: [ "./images/mask/3_2/filter_001.png", "./images/mask/3_2/filter_002.png", "./images/mask/3_2/filter_003.png", "./images/mask/3_2/filter_004.png" ],
        point: [ { x: 145, y: 60 },
                 { x: 165, y: 110 },
                 { x: 100, y: 55 },
                 { x: 85, y: 145 } ],
        match: 0.55,
        dis_match: 0.55,
        is_special: false
    },
    "3_3": {
        filter: [ "./images/mask/3_3/filter_001.png", "./images/mask/3_3/filter_002.png", "./images/mask/3_3/filter_003.png", "./images/mask/3_3/filter_004.png" ],
        point: [ { x: 140, y: 190 },
                 { x: 70,  y: 70 },
                 { x: 110, y: 110 },
                 { x: 100, y: 120 } ],
        match: 0.55,
        dis_match: 0.55,
        is_special: false
    },
    "3_4": {
        filter: [ "./images/mask/3_4/filter_001.png", "./images/mask/3_4/filter_002.png", "./images/mask/3_4/filter_003.png", "./images/mask/3_4/filter_004.png" ],
        point: [ { x: 150, y: 75 },
                 { x: 100, y: 75 },
                 { x: 100, y: 150 },
                 { x: 145, y: 150 } ],
        match: 0.55,
        dis_match: 0.55,
        is_special: false
    },
    "3_5": {
        filter: [ "./images/mask/3_5/filter_001.png", "./images/mask/3_5/filter_002.png", "./images/mask/3_5/filter_003.png", "./images/mask/3_5/filter_004.png" ],
        point: [ { x: 140, y: 80 },
                 { x: 90,  y: 90 },
                 { x: 140, y: 155 },
                 { x: 115, y: 160 } ],
        match: 0.55,
        dis_match: 0.55,
        is_special: false
    },
    "3_6": {
        filter: [ "./images/mask/3_6/filter_001.png", "./images/mask/3_6/filter_002.png", "./images/mask/3_6/filter_003.png", "./images/mask/3_6/filter_004.png" ],
        point: [ { x: 110, y: 75 },
                 { x: 150, y: 155 },
                 { x: 90,  y: 140 },
                 { x: 130, y: 140 } ],
        match: 0.55,
        dis_match: 0.55,
        is_special: false
    },

    "3_7": {
        filter: [ "./images/mask/3_7/filter_001.png", "./images/mask/3_7/filter_002.png", "./images/mask/3_7/filter_003.png", "./images/mask/3_7/filter_004.png" ],
        point: [ { x: 155, y: 160 },
                 { x: 120, y: 90 },
                 { x: 105, y: 110 },
                 { x: 115, y: 155 } ],
        match: 0.55,
        dis_match: 0.55,
        is_special: false
    },
    "3_8": {
        filter: [ "./images/mask/3_8/filter_001.png", "./images/mask/3_8/filter_002.png", "./images/mask/3_8/filter_003.png", "./images/mask/3_8/filter_004.png" ],
        point: [ { x: 165, y: 90 },
                 { x: 155, y: 130 },
                 { x: 100, y: 150 },
                 { x: 100, y: 115 } ],
        match: 0.55,
        dis_match: 0.55,
        is_special: false
    },

    "3_9": {
        filter: [ "./images/mask/3_9/filter_001.png", "./images/mask/3_9/filter_002.png", "./images/mask/3_9/filter_003.png", "./images/mask/3_9/filter_004.png" ],
        point: [ { x: 95,  y: 75 },
                 { x: 95,  y: 140 },
                 { x: 140, y: 105 },
                 { x: 145, y: 165 } ],
        match: 0.55,
        dis_match: 0.55,
        is_special: false
    },
    "3_10": {
        filter: [ "./images/mask/3_10/filter_001.png", "./images/mask/3_10/filter_002.png", "./images/mask/3_10/filter_003.png", "./images/mask/3_10/filter_004.png" ],
        point: [ { x: 115, y: 70 },
                 { x: 100, y: 70 },
                 { x: 100, y: 140 },
                 { x: 130, y: 145 } ],
        match: 0.55,
        dis_match: 0.55,
        is_special: false
    },
};

exports.objCountList = [43, 25, 10];
exports.isInited = false;

exports.setCookie = function(key, value){
    localStorage.setItem(keyPrefix + key, value);
}

exports.getCookie = function(key){
    return localStorage.getItem(keyPrefix + key);
}
exports.removeCookie = function(key){
    localStorage.removeItem(keyPrefix + key);
}
exports.loadFoundList = function(){
    
    let foundModelList = this.getCookie("found_model");
    if(foundModelList === undefined){
        foundModelList = false;
    }else{
        foundModelList = JSON.parse(foundModelList);
    }
    if(!Array.isArray(foundModelList)){
        foundModelList = [];
        for( var j = 0;j < this.objCountList.length;j++ ){
            foundModelList[j] = [];
            for( var i = 0;i < this.objCountList[j];i++ ){
                foundModelList[j][i] = false;
            }
        }
    }
    this.setCookie( "found_model", JSON.stringify(foundModelList) );
    
    return foundModelList;
}

exports.getMaskData = function(id){
    if( id in maskImages ){
        return maskImages[id];
    }
    return null;
}

exports.init = function(){
    
    exports.isInited = true;
}